/**
 * Cancellation Request Status Enum
 *
 * Values synced with backend CancellationRequestStatusEnum.
 * @see backend/src/backend/db/constants/cancellation_request_status.py
 *
 * Backend values:
 * - PENDING = 1
 * - APPROVED = 2
 * - REJECTED = 3
 */
import { intl } from "dmsbasereact";

export const CancellationRequestStatusEnum = {
    PENDING: 1,
    APPROVED: 2,
    REJECTED: 3,
};

export const CancellationRequestStatus = {
    getText: (code) => {
        switch (code) {
            case CancellationRequestStatusEnum.PENDING:
                return intl.get("CancellationRequests.Status.Pending").d("Pending Review");
            case CancellationRequestStatusEnum.APPROVED:
                return intl.get("CancellationRequests.Status.Approved").d("Approved");
            case CancellationRequestStatusEnum.REJECTED:
                return intl.get("CancellationRequests.Status.Rejected").d("Rejected");
            default:
                return intl.get("Unknown").d("Unknown");
        }
    },
    getColor: (code) => {
        switch (code) {
            case CancellationRequestStatusEnum.PENDING:
                return "warning";
            case CancellationRequestStatusEnum.APPROVED:
                return "success";
            case CancellationRequestStatusEnum.REJECTED:
                return "error";
            default:
                return "default";
        }
    }
};

/**
 * Get cancellation request status options for select components
 * @returns {Array} Array of {value, label} objects
 */
export const getCancellationRequestStatusOptions = () => [
    { value: CancellationRequestStatusEnum.PENDING, label: CancellationRequestStatus.getText(CancellationRequestStatusEnum.PENDING) },
    { value: CancellationRequestStatusEnum.APPROVED, label: CancellationRequestStatus.getText(CancellationRequestStatusEnum.APPROVED) },
    { value: CancellationRequestStatusEnum.REJECTED, label: CancellationRequestStatus.getText(CancellationRequestStatusEnum.REJECTED) }
];
